import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

var state = sessionStorage.getItem('state') ? Object.assign(JSON.parse(sessionStorage.getItem('state'))) : {};

state.onlinestate = 'pc'
	function browserRedirect() {
		var sUserAgent = navigator.userAgent.toLowerCase();
		var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
		var bmacintosh = sUserAgent.match(/macintosh/i) == "macintosh";
		var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
		var bIsMidp = sUserAgent.match(/midp/i) == "midp";
		var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
		var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
		var bIsAndroid = sUserAgent.match(/android/i) == "android";
		var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
		var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
		// 您的浏览设备为：
		   if(bIsIphoneOs || bIsAndroid || bIsWM){ 
		       state.onlinestate  = 'phone'
		   } else  if(document.body.clientWidth <= 1100&&bmacintosh){
			state.onlinestate = 'ipad'
		  }
		   else if(bIsIpad){
				state.onlinestate  = 'ipad'
		   }else{ 
		       state.onlinestate  = 'pc'
		   }
	}
	browserRedirect();

if (location.protocol == 'https:') { //正式
	state.urlapi = '/accopen/'//正式
	state.endurl = '/accopen'
}else{
	state.urlapi = '/accopen/'//测试
	state.endurl = '/accopen'
	// state.urlapi = '/newkh/'//测试
	// state.endurl = '/newkh'
}
	// state.sta = true
export default new Vuex.Store({
  state: state,
  mutations: {
    adminlogin (state,data) {
      state.token = data.token;
      state.phone = data.phone;
      state.moveto = data.moveto;
    }
  },
  actions: {

  },
  modules: {

  }
})


